
<div class="UsernameRow">
  <div class="ColorBox" v-bind:style="colorBoxStyle"></div>
  <div>{{ username }}</div>
</div>
